export default "__VITE_ASSET__BWXSelQP__"